/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GithubIssueViewModel } from '../../models/github-issue-view-model';

export interface LinkGitHubIssue$Params {
      body?: {
'IDs'?: Array<number>;
'GitHub_IssueNumber'?: number;
'GitHub_Repository'?: string;
'title'?: string;
'comment'?: string;
}
}

export function LinkGitHubIssue(http: HttpClient, rootUrl: string, params?: LinkGitHubIssue$Params, context?: HttpContext): Observable<StrictHttpResponse<GithubIssueViewModel>> {
  const rb = new RequestBuilder(rootUrl, LinkGitHubIssue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GithubIssueViewModel>;
    })
  );
}

LinkGitHubIssue.PATH = '/api/Tickets/LinkGitHubIssue';
